import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Injectable} from '@angular/core';
import {AppAppearanceService, ColorTheme} from '../services/app-appearance.service';
import {Observable, of} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class SetThemeResolverService  {
  constructor(private appAppearanceService: AppAppearanceService, private auth: AuthService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ColorTheme> {
    if (!environment.enableThemes) {
      this.appAppearanceService.setColorTheme(ColorTheme.DefaultGreen);
      return of(ColorTheme.DefaultGreen);
    }
    if(!this.auth.idenediGroupId){
      this.appAppearanceService.setColorTheme(ColorTheme.DefaultGreen);
      return of(ColorTheme.DefaultGreen);
    }
    return this.appAppearanceService.getAppAppearanceData(this.auth.idenediGroupId).pipe(
      map((appAppearance) => {
        const theme = appAppearance?.theme || ColorTheme.DefaultGreen;
        this.appAppearanceService.setColorTheme(theme);
        return theme;
      }),
      catchError(error => {
        console.warn('SetThemeResolverService: Failed to get theme, using default:', error);
        this.appAppearanceService.setColorTheme(ColorTheme.DefaultGreen);
        return of(ColorTheme.DefaultGreen);
      })
    );
  }
}
